<template>
  <div>
    <Bar :data="chartData" :options="chartOptions" />
  </div>
</template>

<script lang="ts">
import 'chart.js/auto';
import { Chart } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import { Bar } from 'vue-chartjs';
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import Colors from '@/infrastructure/support/Colors.ts';
import YieldFormatter from '@/presentation/mixins/YieldFormatter.js';

Chart.register(Annotation);

export default {
  name: 'LongTermPeriodProgressChart',
  components: { Bar },
  mixins: [YieldFormatter],
  props: {
    period: { type: YieldPromiseStatus, required: true },
  },
  computed: {
    chartData() {
      return {
        labels: [this.period.getPeriodStartRaw()],
        datasets: [
          {
            yID: 'progress-axis',
            label: this.$t('features.long_term.progress') + ' (%)',
            backgroundColor: Colors.actualYieldColor(),
            data: [this.realizedProgress],
          },
        ],
      };
    },
    chartOptions() {
      return {
        indexAxis: 'y',
        scales: {
          x: {
            id: 'x',
            title: {
              display: true,
              text: this.$t('features.long_term.period_progress') + ' (%)',
            },
            beginAtZero: true,
            suggestedMax: 110,
          },
          y: {
            id: 'progress-axis',
            display: false,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        tooltips: { callbacks: {} },
        plugins: {
          legend: { display: false },
          annotation: {
            annotations: [
              {
                type: 'line',
                mode: 'vertical',
                scaleID: 'x',
                value: this.period.getRadiationReceived().asPercentage(),
                borderColor: Colors.expectedYieldColor(),
                borderWidth: 2,
                label: {
                  display: true,
                  yAdjust: 12,
                  content: this.period.isOngoing()
                    ? this.$t('features.long_term.promised_till_now')
                    : this.$t('features.long_term.promised'),
                },
              },
            ],
          },
        },
      };
    },
    realizedProgress() {
      return this.period
        .getDeliveredTillNow()
        .divideBy(this.period.getPromisedTillNow())
        .times(this.period.getRadiationReceived().asRatio())
        .asPercentage()
        .toFixed(2);
    },
  },
};
</script>
